export function undefinedIfEmpty(value?: string, trimValue = false): string | undefined {
    const trimmedValue = trimValue ? value?.trim() : value;
    return trimmedValue && trimmedValue.trim() !== "" ? trimmedValue : undefined;
}

export function nullIfEmpty(value?: string, trimValue = false): string | null {
    const trimmedValue = trimValue ? value?.trim() : value;
    return trimmedValue && trimmedValue.trim() !== "" ? trimmedValue : null;
}